import * as qiniu from 'qiniu-js'

interface Option {
  file: File
  onProgress: (progress: object) => void
  onError: (error: Error) => void
  onSuccess: (response: object) => void
}

/**
 * 七牛 - el-upload 模块
 *
 * @param {string} token 七牛token
 */
export default function uploader(token: string) {
  return (opt: Option): qiniu.ISubseribe => {
    const { file } = opt
    const qnUpload = qiniu.upload(file, undefined, token)
    const next = ({ total }) => {
      opt.onProgress({ percent: total.percent })
    }

    const complete = res => opt.onSuccess(res)

    const error = err => opt.onError(err)

    const subscription = qnUpload.subscribe({ next, error, complete })
    return subscription
  }
}
